import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getCorrespondenceCopies = (state) => allModelsSelector(state, 'CorrespondenceCopy');
